import { ITCFConsent, ITCFVendorCategory } from "../TCFConsentProvider/types";

const isTCFCategoryAccepted = (
  name: ITCFVendorCategory,
  id: number,
  tempConsent: ITCFConsent
): boolean => {
  // Check if category is already accepted. Its structured like this to prevent trying to read "[id]" of undefined
  return !!(tempConsent.categories[name] || {})[id];
};

export default isTCFCategoryAccepted;
